/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M6 9L9 6M6 9L9 12M6 9H10.6C12.8402 9 13.9603 9 14.816 9.43597C15.5686 9.81947 16.1805 10.4314 16.564 11.184C17 12.0397 17 13.1598 17 15.4V17.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				width="20"
				height="20"
				rx="5"
				transform="matrix(1 0 0 -1 2 22)"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M6 9L9 6M6 9L9 12M6 9H9.5C11.8297 9 12.9946 9 13.9134 9.3806C15.1386 9.88807 16.1119 10.8614 16.6194 12.0866C17 13.0054 17 14.1703 17 16.5V16.5V17.0001M10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM9.53033 6.53033C9.82322 6.23744 9.82322 5.76256 9.53033 5.46967C9.23744 5.17678 8.76256 5.17678 8.46967 5.46967L5.46967 8.46967C5.17678 8.76256 5.17678 9.23744 5.46967 9.53033L8.46967 12.5303C8.76256 12.8232 9.23744 12.8232 9.53033 12.5303C9.82322 12.2374 9.82322 11.7626 9.53033 11.4697L7.81066 9.75H10.6C11.7325 9.75 12.5367 9.75058 13.1661 9.80201C13.7867 9.85271 14.171 9.94909 14.4755 10.1042C15.087 10.4158 15.5842 10.913 15.8958 11.5245C16.0509 11.829 16.1473 12.2133 16.198 12.8339C16.2494 13.4633 16.25 14.2675 16.25 15.4V17.0001C16.25 17.4143 16.5858 17.7501 17 17.7501C17.4142 17.7501 17.75 17.4143 17.75 17.0001V15.4V15.367V15.3669C17.75 14.2748 17.75 13.4093 17.693 12.7117C17.6347 11.9983 17.5131 11.3947 17.2323 10.8435C16.7769 9.94978 16.0502 9.22312 15.1565 8.76772C14.6053 8.48688 14.0017 8.36527 13.2883 8.30699C12.5906 8.24999 11.7251 8.25 10.633 8.25H10.633H10.6H7.81066L9.53033 6.53033Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M6 9L9 6M6 9L9 12M6 9H9.5C11.8297 9 12.9946 9 13.9134 9.3806C15.1386 9.88807 16.1119 10.8614 16.6194 12.0866C17 13.0054 17 14.1703 17 16.5V16.5V17.0001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 9L9 6M6 9L9 12M6 9H9.5C11.8297 9 12.9946 9 13.9134 9.3806C15.1386 9.88807 16.1119 10.8614 16.6194 12.0866C17 13.0054 17 14.1703 17 16.5V16.5V17.0001M10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.53033 5.46959C9.82322 5.76248 9.82322 6.23736 9.53033 6.53025L7.81066 8.24992H10.6H10.633C11.7251 8.24992 12.5906 8.24991 13.2883 8.30691C14.0017 8.36519 14.6053 8.4868 15.1565 8.76764C16.0502 9.22304 16.7769 9.9497 17.2323 10.8435C17.5131 11.3946 17.6347 11.9983 17.693 12.7117C17.75 13.4093 17.75 14.2748 17.75 15.3669V15.3999V17C17.75 17.4142 17.4142 17.75 17 17.75C16.5858 17.75 16.25 17.4142 16.25 17V15.3999C16.25 14.2674 16.2494 13.4632 16.198 12.8338C16.1473 12.2132 16.0509 11.8289 15.8958 11.5245C15.5842 10.9129 15.087 10.4157 14.4755 10.1041C14.171 9.94901 13.7867 9.85263 13.1661 9.80193C12.5367 9.7505 11.7325 9.74992 10.6 9.74992H7.81066L9.53033 11.4696C9.82322 11.7625 9.82322 12.2374 9.53033 12.5303C9.23744 12.8231 8.76256 12.8231 8.46967 12.5303L5.46967 9.53025C5.17678 9.23736 5.17678 8.76248 5.46967 8.46959L8.46967 5.46959C8.76256 5.1767 9.23744 5.1767 9.53033 5.46959Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
